//@ts-nocheck
import React from 'react';
import { Card, Badge } from 'react-bootstrap';

const OrderInfoCard = ({ order, formatDate, getStatusBadge }) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <h6 className="mb-0">Informacje o zamówieniu</h6>
      </Card.Header>
      <Card.Body>
        <div className="mb-2">
          <strong>Numer zamówienia:</strong>
          <div>{order.orderNumber || order.number}</div>
        </div>
        <div className="mb-2">
          <strong>Status:</strong>
          <div>{getStatusBadge(order.status)}</div>
        </div>
        <div className="mb-2">
          <strong>Producent:</strong>
          <div>
            {typeof order.producer === 'object'
              ? order.producer?.name
              : order.producer}
          </div>
        </div>
        <div className="mb-2">
          <strong>Data utworzenia:</strong>
          <div>{formatDate(order.createdAt)}</div>
        </div>
        {order.completedAt && (
          <div className="mb-2">
            <strong>Data realizacji:</strong>
            <div>{formatDate(order.completedAt)}</div>
          </div>
        )}
        {order.receivedAt && (
          <div className="mb-2">
            <strong>Data odbioru:</strong>
            <div>{formatDate(order.receivedAt)}</div>
          </div>
        )}
        <div className="mb-2">
          <strong>Utworzone przez:</strong>
          <div>
            {order.user?.firstname} {order.user?.lastname}
            {order.user?.company && ` (${order.user.company})`}
          </div>
        </div>
        {order.receivedBy && (
          <div className="mb-2">
            <strong>Odebrane przez:</strong>
            <div>
              {order.receivedBy?.firstname} {order.receivedBy?.lastname}
            </div>
          </div>
        )}
        {order.notes && (
          <div className="mb-2">
            <strong>Uwagi:</strong>
            <div>{order.notes}</div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default OrderInfoCard;
